import { render, staticRenderFns } from "./DeleteTaskDataPointPopup.vue?vue&type=template&id=36853da2&scoped=true&"
import script from "./DeleteTaskDataPointPopup.vue?vue&type=script&lang=ts&"
export * from "./DeleteTaskDataPointPopup.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteTaskDataPointPopup.vue?vue&type=style&index=0&id=36853da2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36853da2",
  null
  
)

export default component.exports